import { useContext } from 'react';
import { AuthContext } from '../Context/AuthContext';

const usePermissions = () => {
    const { authInfo } = useContext(AuthContext);
    const user = authInfo?.user ?? {};
    const permissions = Array.isArray(user.permissions) ? user.permissions : [];
    const typeUser = user.type_user;
    const userId = user.id ?? null;

    const can          = (key) => permissions.includes(key);
    const isAdminPei   = () => typeUser === '1';
    const isVendedorPei= () => typeUser === '2';
    const isAdminTrim  = () => typeUser === '3';
    const isVendedorTrim = () => typeUser === '4';
    const isVendedor   = () => typeUser === '2' || typeUser === '4';
    const isAnyAdmin   = () => typeUser === '1' || typeUser === '3';

    return {
        can,
        isAdminPei,
        isVendedorPei,
        isAdminTrim,
        isVendedorTrim,
        isVendedor,
        isAnyAdmin,
        permissions,
        typeUser,
        userId,
    };
};

export default usePermissions;
